import { appTheme } from '../theme';

/** Vertical rhythm for auth forms (login, register, OTP, reset). */
export const authSheetFormSpacing = {
  /**
   * Extra top padding inside scroll content when `mainScreenIntrinsic` (MainScreen dock).
   * Used by hero_dock login/register when embedded in main onboarding.
   */
  mainScreenIntrinsicFormTopPadding: appTheme.spacing.sm,
  /** Scroll content inset under chrome header (center card — no safe-area). */
  formPaddingTop: appTheme.spacing.md,
  /** Scroll content bottom inset inside the card. */
  formPaddingBottom: appTheme.spacing.md,
  /** Space below header block (logo + intro copy). */
  afterHeader: appTheme.spacing.md,
  /** Space between last inline link (e.g. forgot password) and primary button stack. */
  beforePrimaryActions: appTheme.spacing.md,
  beforePrimaryActionsMainScreen: appTheme.spacing.md,
  /** Space between primary button stack and footer row (e.g. sign up / sign in). */
  afterPrimaryActions: appTheme.spacing.md,
  afterPrimaryActionsMainScreen: appTheme.spacing.md,
  /** Space above terms checkbox row (register). */
  beforeTermsRow: appTheme.spacing.sm,
};

/**
 * Bottom bias for compact auth cards (login/register).
 * `placement=center` + `flex-end` → larger fraction = higher on screen (over main Login/Register CTAs).
 */
export const AUTH_CENTER_BOTTOM_INSET_FRACTION = 0.16;

/** Keyboard clearance for auth form focus scroll / modal lift. */
export const AUTH_FORM_KEYBOARD = {
  panelClearancePx: appTheme.spacing.sm,
  /** Space kept between focused field bottom and keyboard top — only when overlapping. */
  fieldFocusClearancePx: appTheme.spacing.sm,
};
